module.exports = __webpack_public_path__ + "img/bold-01.ea06e398.svg";